<template>
  <div class="home">
    <!-- <div class="diandi"></div> -->
    <div v-wechat-title="$route.meta.title"></div>
    <div class="dhtBox">
      <div class="cdBox">
        <div class="logo"></div>

        <div @click="shouye" class="cd bxz">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd(hsk)" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img
                  src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg"
                  alt=""
                />
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>
      </div>
    </div>
    <div class="lbBox">
      <div class="lbBoxtext">
        <!-- <div class="lbBoxtexts lbBoxtexts1">
            互联网
        </div> -->
        <div class="lbBoxtexts lbBoxtexts1">新零售运营服务商</div>
        <div class="lbBoxtexts lbBoxtexts2">
          积分兑换平台+互联网技术应用+新零售运营支持+售后服务管理
        </div>
        <div class="lbBoxtexts lbBoxtexts2">全方位智慧营销赋能</div>
        <div class="lbBoxtexts lbBoxtexts2">
          为实体商家插上互联网新零售的翅膀
        </div>
      </div>
    </div>
    <!-- <div class="chanpinBox">
      <div class="chanpin">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48378.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">商e通</div>
          <div class="chanpinText2">数字营销 大数据分析后台</div>
        </div>
        <div class="chanpins">
          数字营销大数据后台，深度解析零售大数据，掌握客户群体属性分布。以数据驱动营销，便捷高效管理运营
        </div>
      </div>
      <div class="chanpin">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48381.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米商云</div>
          <div class="chanpinText2">全终端覆盖 私域流量商城</div>
        </div>
        <div class="chanpins">
          迷商云平台基于拓宽新零售渠道，助力实体商家“提升销售业绩和客户服务管理”小程序+公众号+商城，全终端覆盖、统一管理后台
        </div>
      </div>
      <div class="chanpin">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48382.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米小包</div>
          <div class="chanpinText2">营销互动 海量营销工具包</div>
        </div>
        <div class="chanpins">
          实现拼团、砍价、秒杀、满减满赠、优惠卷、推荐有礼、限时购、大转盘、砸金蛋、预售、储值卡、礼品卡等工具包，支持商家按需部署使用
        </div>
      </div>
      <div class="chanpin">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48383.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米小礼</div>
          <div class="chanpinText2">新零售 积分兑换营销兑换平台</div>
        </div>
        <div class="chanpins">
          超强供应链整合，严选礼品，聚集5000个SKU；平台生活化运营，满足客户多样化产品需求。助力提升客户全生命价值周期关系管理
        </div>
      </div>
      <div class="chanpin">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48389.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">嘉佳纺生活</div>
          <div class="chanpinText2">美好生活方式的缔造者</div>
        </div>
        <div class="chanpins">
          提供多元化服务，满足用户更多购物需求，共同缔造美好生活方式！
        </div>
      </div>
    </div> -->
    <div class="chanpinBox">
      <div class="chanpin" @mouseover="productChange(0)">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48378.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米商云</div>
          <div class="chanpinText2">智慧零售 一站式新零售运营服务平台</div>
        </div>
      </div>
      <div class="chanpin" @mouseover="productChange(1)">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48381.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米小包</div>
          <div class="chanpinText2">智慧营销 线上一键触达会员的营销工具包</div>
        </div>
      </div>
      <div class="chanpin" @mouseover="productChange(2)">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48382.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米小秘</div>
          <div class="chanpinText2">智慧管理 新一代员工积分管理解决方案</div>
        </div>
      </div>
      <div class="chanpin" @mouseover="productChange(3)">
        <div class="chanpinImg">
          <img class="img" src="../../assets/images/-48383.png" alt="" />
        </div>
        <div class="chanpinText">
          <div class="chanpinText1">米小礼商务版</div>
          <div class="chanpinText2">智慧经营 会员全生命周期积分制管理</div>
        </div>
      </div>
    </div>
    <div class="product-introduction">
      <img
        :class="productIndex == 0 ? 'product show' : 'product'"
        src="../../assets/images/product_msy.jpg"
        alt=""
      />
      <img
        :class="productIndex == 1 ? 'product show' : 'product'"
        src="../../assets/images/product_mxb.jpg"
        alt=""
      />
      <img
        :class="productIndex == 2 ? 'product show' : 'product'"
        src="../../assets/images/product_mxm.jpg"
        alt=""
      />
      <img
        :class="productIndex == 3 ? 'product show' : 'product'"
        src="../../assets/images/product_swb.jpg"
        alt=""
      />
    </div>
    <div class="ggci">智能营销数据分析体系 覆盖所有数据维度</div>
    <div class="nr1Box">
      <div class="nr">
        <div class="nrLeft">
          <div class="nrLeftText1">全链路数据分析 全场景精准营销</div>
          <div class="nrLeftText2">
            商E通依托大数据云平台，提供流量分析、交易分析、客户行为分析，为客户进行标签化
            用户画像更加精准掌握专属私域流量。
          </div>
          <div class="nrLeftText2">
            根据消费者的全场景消费习惯及频次，帮助你更加了解客户；掌握客户喜好，定向推送精
            准商品，提升成交。
          </div>
          <div class="nrLeftText3">全数据精准分析</div>
          <div class="nrLeftText4">海量智库赋能</div>
          <div class="nrLeftText3">1折爆品商城</div>
        </div>
        <div class="nrRight">
          <img class="img" src="../../assets/images/182.png" alt="" />
        </div>
      </div>
    </div>
    <div class="ggciBox">
      <div class="ggci">全行业营销场景赋能 无死角覆盖私域流量</div>
      <div class="zzfxBox">
        <div class="zzfx">
          <img class="img" src="../../assets/images/-43192.png" alt="" />
          <p class="p ps">高效</p>
          <p class="p">高效管理私有商城</p>
          <p class="p">高效管理订单</p>
          <p class="p">高效管理客户信息</p>
        </div>
        <div class="zzfx">
          <img class="img" src="../../assets/images/-43193.png" alt="" />
          <p class="p ps">智能</p>
          <p class="p">智能沉淀优质客户</p>
          <p class="p">智能管理营销业绩</p>
        </div>
        <div class="zzfx">
          <img class="img" src="../../assets/images/-43194.png" alt="" />
          <p class="p ps">多维</p>
          <p class="p">无边界覆盖 获客拉新</p>
          <p class="p">全场景体验 提升转化</p>
          <p class="p">多终端营销 统一管理</p>
        </div>
        <div class="zzfx">
          <img class="img" src="../../assets/images/-43191.png" alt="" />
          <p class="p ps">联盟</p>
          <p class="p">全场景产品联盟</p>
          <p class="p">获取多链条客户</p>
          <p class="p">跨场景增曝光增收</p>
        </div>
      </div>
    </div>
    <div class="ggciBoxs">
      <div class="ggci ggciBoxsstyle">赋能全场景营销的互联网产品</div>
      <div class="sigefangxiang">
        <div class="text">众多的营销流量入口</div>
        <div class="text">线上引流</div>
        <div class="text">帮助商家获得更多精准新用户</div>
        <div class="text">跨场景增收</div>
      </div>
    </div>
    <div class="lqdBox">
      <div class="lqd">
        <div class="text1">多终端营销工具触手 全方位覆盖场景用户</div>
        <div style="display: flex">
          <div class="left">
            <div class="left1">赋能全场景营销流量玩法</div>
            <div class="left2">
              实现拼团、砍价、秒杀、满减满赠、优惠券、推荐、有礼、限时购、大转盘、
              砸金蛋、预售、储值卡、礼品卡等工具包玩法，不断活跃目标客户群体，拉
              高订单转化和日常到店进场。
            </div>
          </div>
          <div class="right">
            <div class="right1">
              <div class="right1_left">
                <img class="img" src="../../assets/images/-48526.png" alt="" />
              </div>
              <div class="right1_right">
                <div class="right1_right_text1"><b>简单</b></div>
                <div class="right1_right_text2">
                  操作简单一键生成 管理简单随时掌控 链路简单精准触达
                </div>
              </div>
            </div>
            <div class="right2"></div>
          </div>
          <div class="right">
            <div class="right1">
              <div class="right1_left">
                <img class="img" src="../../assets/images/-48524.png" alt="" />
              </div>
              <div class="right1_right">
                <div class="right1_right_text1"><b>有效</b></div>
                <div class="right1_right_text2">
                  拉动目标直接有效 提升营销直接有效
                </div>
              </div>
            </div>
            <div class="right2"></div>
          </div>
        </div>
        <div style="display: flex; padding-left: 4rem">
          <div class="right">
            <div class="right1">
              <div class="right1_left">
                <img class="img" src="../../assets/images/-48522.png" alt="" />
              </div>
              <div class="right1_right">
                <div class="right1_right_text1"><b>有趣</b></div>
                <div class="right1_right_text2">
                  形式多样拒绝单一 沉浸式玩法诱人投入 娱乐性心里传播有趣
                </div>
              </div>
            </div>
            <div class="right2"></div>
          </div>
          <div class="right">
            <div class="right1">
              <div class="right1_left">
                <img class="img" src="../../assets/images/-48518.png" alt="" />
              </div>
              <div class="right1_right">
                <div class="right1_right_text1"><b>有量</b></div>
                <div class="right1_right_text2">
                  触达用户有质量 <br />
                  拉动用户有销量 <br />
                  裂变玩法高曝光
                </div>
              </div>
            </div>
            <div class="right2"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="ggciBoxs" style="background: #fff">
      <div class="ggci ggciBoxsstyle">赋能全场景营销的互联网产品</div>
      <div class="nr1Box nr1Boxs">
        <div class="nr">
          <div class="nrRight nrRights">
            <img class="img" src="../../assets/images/187.png" alt="" />
          </div>
          <div class="nrLeft nrLefts">
            <div class="nrLeftText1">全行业客户覆盖 全周期精准培养</div>
            <div class="nrLeftText2">
              万千礼品随心选尽情兑，超强供应链整合，严选礼品，确保品控标准。聚集13个大品类、
              50多个小品类、几千个SKU；平台生活化运营，满足客户多样化产品需求。
            </div>
            <div class="nrLeftText2">
              助力提升客户全生命价值周期关系管理，全面提升商家与客户的强关系粘性。
            </div>
            <div class="nrLeftText3 nrLeftText3s">品类齐全多样化</div>
            <div class="nrLeftText4 nrLeftText4s">助力营销粘性增强</div>
            <div class="nrLeftText3 nrLeftText3s">活动导流精准化</div>
          </div>
        </div>
      </div>
    </div>
    <div class="gg2Box">
      <div class="boxbox">
        <div class="gg2text"></div>
        <div class="gg2xuanxBox">
          <div class="gg2">
            <img src="../../assets/images/111111.png" alt="" />
          </div>
          <div class="gg2">
            <img src="../../assets/images/222222.png" alt="" />
          </div>
          <div class="gg2">
            <img src="../../assets/images/333333.png" alt="" />
          </div>
        </div>
        <div
          class="gg2btn"
          onclick="javascript:document.getElementById('add').scrollIntoView()"
        >
          联系我们
        </div>
      </div>
    </div>
    <!-- <div class="sxyboxbox">
      <div class="sxybox">
        <div class="bt">商学院</div>
        <div class="syxsbox">
          <div class="syxs">
            <div class="img1">
              <div class="text">创业者孵化器销售精益创业公司</div>
            </div>
            <div class="shijian">2020 - 03 - 24</div>
          </div>
          <div class="syxs">
            <div class="img2">
              <div class="text">创业者孵化器销售精益创业公司</div>
            </div>
            <div class="shijian">2020 - 03 - 24</div>
          </div>
          <div class="syxs">
            <div class="img3">
              <div class="text">创业者孵化器销售精益创业公司</div>
            </div>
            <div class="shijian">2020 - 03 - 24</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="rarterboxbox">
      <div class="rarterbox">
        <div class="btbox">
          <div class="bttext1">PARTNER</div>
          <div class="bttext2">/ 合 / 作 / 伙 / 伴 /</div>
        </div>
      </div>
      <div class="lbttbox">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/7.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/8.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/9.png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/10.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/111.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/222.png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/333.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/444.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/555.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (1).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (2).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (3).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (4).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (5).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (6).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (7).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (8).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (9).png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (10).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (11).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (12).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (13).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (14).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (15).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (16).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (17).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (18).png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (19).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (20).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (21).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (22).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (23).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (24).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (25).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (26).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (27).png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (28).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (29).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (30).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (31).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (23).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (32).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (33).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (34).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <!-- <img src="../../assets/images/hzppt/g1 (27).png" alt="" /> -->
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- <div class="rarterboxbox">
      <div class="rarterbox">
        <div class="btbox">
          <div class="bttext1">PARTNER</div>
          <div class="bttext2">/ 合 / 作 / 伙 / 伴 /</div>
        </div>
        <div style="display: flex; justify-content: center">
          <div class="hezidebox">
            <div class="shangpinsbox">
              <div class="shangpins">
                <img src="../../assets/images/7.png" alt="" />
              </div>
              <div class="shangpins">
                <img src="../../assets/images/8.png" alt="" />
              </div>
              <div class="shangpins">
                <img src="../../assets/images/9.png" alt="" />
              </div>
            </div>

            <div class="shugang"></div>
          </div>
          <div class="hezidebox">
            <div class="shangpinsbox">
              <div class="shangpins">
                <img src="../../assets/images/10.png" alt="" />
              </div>
              <div class="shangpins">
                <img src="../../assets/images/111.png" alt="" />
              </div>
              <div class="shangpins">
                <img src="../../assets/images/222.png" alt="" />
              </div>
            </div>

            <div class="shugang"></div>
          </div>
          <div class="hezidebox">
            <div class="shangpinsbox">
              <div class="shangpins">
                <img src="../../assets/images/333.png" alt="" />
              </div>
              <div class="shangpins">
                <img src="../../assets/images/444.png" alt="" />
              </div>
              <div class="shangpins">
                <img src="../../assets/images/555.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="tijiaoboxbox" id="add">
      <div class="tijiaobox">
        <div class="biaoti">营销落地 顺势而为</div>
        <div class="biaogebox">
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="姓名"
              id="txt"
              value=""
              ref="name1"
              v-on:keyup="inputRef1"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="手机"
              id="txt"
              value=""
              ref="name2"
              v-on:keyup="inputRef2"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="公司名称"
              id="txt"
              value=""
              ref="name3"
              v-on:keyup="inputRef3"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="省份"
              id="txt"
              value=""
              ref="name4"
              v-on:keyup="inputRef4"
            />
          </div>
        </div>
        <div class="tijiaobtn" @click="ziliao()">立即申请</div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/service/common.service.js";
export default {
  data() {
    return {
      name1: "name1",
      name2: "name2",
      name3: "name3",
      name4: "name4",
      hsk: 1,
      // 项目展示索引
      productIndex: 0,
    };
  },
  // created(){
  //   this.$$nextTick( function () {
  //     this.getlocal()
  //   })
  // },
  mounted() {
    // 页面加载的时候直接运行就可以拿到url中的projectId，进而进行下面的业务 projectId是想要获取的参数名
    let projectId = this.$utils.getUrlKey("projectId");
    // console.log(projectId)
    if (projectId == 1) {
      this.$toast("请点击右上角... 分享");
    }

    // this.createMap();
    // this.$nextTick( function (){
    //   window.addEventListener('scroll' , this.handleScroll)
    // })
  },
  methods: {
    // 切换项目展示图
    productChange(i) {
      console.log(i);
      this.productIndex = i;
    },
    // getlocal(){
    //   let select = localStorage.getItem('id');
    //   let elm = document.getElementById(select)
    //   if(select ){
    //     elm.scrollIntoView(true)
    //   }
    // },

    // destroyed(){
    //   localStorage.setItem('id' , '');
    // },

    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    ydd(e) {
      if (e == 1) {
        this.hsk = 2;
      } else {
        this.hsk = 1;
      }
      console.log(this.hsk);
    },
    shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.home {
  .my-swipe {
    width: 1200px;
    .van-swipe-item {
      color: #fff;
      font-size: 20px;
      line-height: 4.8rem;
      text-align: center;
      background-color: #fbfbfb;
    }
  }
  font-size: 0.16rem;
  background: #fff;
  .dhtBox {
    .bxz {
      border-bottom: 2px solid #fff;
    }
  }
  .lbBox {
    // width: 100%;
    height: 8rem;
    background: url("../../../src/assets/images/11.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 2.5rem;
    box-sizing: border-box;
    .lbBoxtext {
      width: 1200px;
      margin: 0 auto;
      .lbBoxtexts {
        text-align: left;
      }
      .lbBoxtexts1 {
        font-size: 0.6rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
      .lbBoxtexts1:nth-child(2) {
        margin-bottom: 0.3rem;
      }
      .lbBoxtexts2 {
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #fffefe;
        line-height: 0.38rem;
        margin-bottom: 0.1rem;
      }
    }
  }
  .chanpinBox {
    width: 12rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    margin: 0 auto;
    margin-top: -0.7rem;
    background: #ffffff;
    box-shadow: 0rem 0.05rem 0.15rem 0rem rgba(0, 0, 0, 0.06);
    border-radius: 0.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    .chanpin {
      width: 2.2rem;
      height: 0.6rem;
      // border: 1px solid red;
      border-right: 1px solid #e4e5e5;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      position: relative;
      .chanpinImg {
        width: 0.5rem;
        height: 0.5rem;
        // background: url('../../assets/images/-48378.png');
        // background-size: 100% 100%;
        margin-right: 0.2rem;
        .img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
      .chanpinText {
        width: 1rem;
        .chanpinText1 {
          margin-bottom: 0.06rem;
          font-weight: 700;
        }
        .chanpinText2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
        }
      }
      .chanpins {
        display: none;
        width: 2.1rem;
        height: 0.6rem;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        background: #fff;
        padding-left: 0.2rem;
        padding-right: 0.2rem;
        box-sizing: border-box;
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #6c6c6c;
        //  text-overflow: -o-ellipsis-lastline;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 3;
        // line-clamp: 3;
        // -webkit-box-orient: vertical;
      }
    }
    .chanpin:nth-child(5) {
      border-right: none;
    }
    .chanpin:hover > .chanpins {
      display: block;
    }
  }
  .product-introduction {
    width: 12rem;
    padding-bottom: 0.5rem;
    margin: 0 auto;
    .product {
      width: 100%;
      display: none;
      margin: 0 auto;
      &.show {
        display: block;
      }
    }
  }
  .ggci {
    width: 100%;
    height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.34rem;
    font-family: Source Han Sans CN;
    font-weight: bold;
    margin-bottom: 0.2rem;
  }
  .ggciBox {
    padding-top: 1.3rem;
    background: #fbfbfb;
    .ggci {
      margin-bottom: 1.18rem;
    }
    .zzfxBox {
      width: 12rem;
      padding-bottom: 0.2rem;
      background: #fbfbfb;
      border-radius: 0.2rem;
      margin: 0 auto;
      display: flex;
      cursor: pointer;
      .zzfx {
        width: 2.86rem;
        height: 3.44rem;
        background: #ffffff;
        border-radius: 0.2rem;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        .img {
          display: block;
          width: 0.69rem;
          height: 0.69rem;
          margin: 0 auto;
          margin-top: 0.6rem;
          margin-bottom: 0.4rem;
        }
        .p {
          text-align: center;
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #707070;
        }
        .ps {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #252525;
          margin-bottom: 0.25rem;
        }
      }
      .zzfz:nth-child(1) {
        margin-left: 0;
      }
      .zzfz:nth-child(4) {
        margin-right: 0;
      }
      .zzfx:hover {
        box-shadow: -0.01rem 0.05rem 0.16rem 0rem rgba(0, 0, 0, 0.06);
      }
    }
  }
  .nr1Box {
    width: 100%;
    background: url("../../assets/images/184.png") no-repeat center;
    background-size: 100%;
    padding-bottom: 2rem;
    .nr {
      width: 12rem;
      margin: 0 auto;
      display: flex;
      flex-flow: wrap;
      .nrLeft {
        width: 5.5rem;
        margin-top: 2.5rem;
        margin-right: 0.5rem;
        .nrLeftText1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #000000;
          display: flex;
          // justify-content: center;
          align-items: center;
          margin-bottom: 0.3rem;
        }
        .nrLeftText2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
          line-height: 38px;
          margin-bottom: 0.3rem;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 0.2rem;
        }
        .nrLeftText4 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
          margin-left: 1.18rem;
        }
        .nrLeftText4s {
          margin-left: 0.2rem;
          background: #4273fd;
          color: #fff;
        }
        .nrLeftText3 {
          width: 4.05rem;
          height: 1.08rem;
          background: #ffffff;
          box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
          border-radius: 0.2rem;
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #2b79f5;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 0.5rem;
        }
        .nrLeftText3s {
          margin-left: 1.44rem;
          background: #4273fd;
          color: #fff;
        }
      }
      .nrLefts {
        margin-right: 0;
      }
      .nrRight {
        width: 5rem;
        margin-left: 1rem;
        margin-top: 0.78rem;
        .img {
          display: block;
          width: 100%;
          height: 1005;
          width: 4.56rem;
          height: 9.33rem;
          margin: 0 auto;
        }
      }
      .nrRights {
        margin-left: 0rem;
        margin-top: 0rem;
        margin-right: 1.5rem;
      }
    }
  }
  .nr1Boxs {
    background: url("../../assets/images/183.png") no-repeat center;
    background-size: 100%;
    margin-bottom: 1.5rem;
  }
  .ggciBoxs {
    padding-top: 0.9rem;
    background: #fbfbfb;
    .ggciBoxsstyle {
      margin-bottom: 0.4rem;
    }
    .sigefangxiang {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 1.02rem;
      .text {
        margin-right: 0.3rem;
        margin-left: 0.3rem;
        font-size: 0.14rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #6c6c6c;
      }
      .text:nth-child(1) {
        margin-left: 0;
      }
      .text:nth-child(4) {
        margin-right: 0;
      }
    }
  }
  .lqdBox {
    width: 100%;
    padding-bottom: 0.6rem;
    background: url("../../assets/images/188.png") no-repeat center;
    background-size: 100% 100%;
    .lqd {
      width: 1200px;
      padding-top: 1rem;
      box-sizing: border-box;
      margin: 0 auto;
      .text1 {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        margin-bottom: 0.97rem;
      }
      .left {
        width: 4.8rem;
        margin-right: 0.8rem;
        .left1 {
          font-size: 0.32rem;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 0.5rem;
        }
        .left2 {
          font-size: 0.14rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #efeeee;
          line-height: 38px;
        }
      }
      .right {
        display: flex;
        margin-left: 0.1rem;
        margin-right: 0.1rem;
        margin-bottom: 0.18rem;
        .right1 {
          width: 3.1rem;
          height: 1.96rem;
          background: #ffffff;
          border-radius: 0.2rem;
          display: flex;
          .right1_left {
            width: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;

            .img {
              display: block;
              width: 0.66rem;
              height: 0.66rem;
            }
          }
          .right1_right {
            width: 1.2rem;
            .right1_right_text1 {
              margin-bottom: 0.28rem;
              margin-top: 0.39rem;
            }
            .right1_right_text2 {
              line-height: 0.29rem;
              text-align: center;
              font-size: 0.13rem;
            }
            .right1_right_text2_xiusui {
            }
          }
        }
      }
    }
  }
  .gg2Box {
    width: 100%;
    background: url("../../assets/images/1880.png") no-repeat center;
    background-size: 100% 100%;
    padding-top: 0.98rem;
    padding-bottom: 0.7rem;
    .boxbox {
      width: 1200px;
      margin: 0 auto;
      .gg2text {
        width: 7.82rem;
        height: 0.42rem;
        background: url("../../assets/images/1111.png") no-repeat center;
        background-size: 100% 100%;
        margin: 0 auto;
        margin-bottom: 1.1rem;
      }
      .gg2xuanxBox {
        width: 1200px;
        height: 2.56rem;
        display: flex;
        margin-bottom: 1rem;
        .gg2 {
          width: 4.22rem;
          height: 2.56rem;
          .img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
      }
      .gg2btn {
        width: 2.19rem;
        height: 0.76rem;
        background: #ffffff;
        // box-shadow: -0.01rem 0.05rem 0.3rem 0rem rgba(0, 0, 0, 0.1);
        box-shadow: -1px 5px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 0.1rem;
        font-size: 0.28rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #2d5eff;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }
  .sxyboxbox {
    width: 100%;
    height: 7rem;
    background: #fff;
    .sxybox {
      width: 1200px;
      margin: 0 auto;
      .bt {
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1.3rem;
        margin-bottom: 0.87rem;
      }
      .syxsbox {
        display: flex;
        .syxs {
          width: 3.87rem;
          height: 3.4rem;
          margin-left: 0.1rem;
          margin-right: 0.1rem;
          .img1 {
            width: 3.87rem;
            height: 2.89rem;
            position: relative;
            margin-bottom: 0.1rem;
            background: url("../../assets/images/70.png") no-repeat center;
            background-size: 100% 100%;
            .text {
              width: 100%;
              height: 0.52rem;
              background: rgba(0, 0, 0, 0.2);
              font-size: 0.2rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              bottom: 0;
            }
          }
          .img2 {
            width: 3.87rem;
            height: 2.89rem;
            position: relative;
            margin-bottom: 0.1rem;
            background: url("../../assets/images/71.png") no-repeat center;
            background-size: 100% 100%;
            .text {
              width: 100%;
              height: 0.52rem;
              background: rgba(0, 0, 0, 0.2);
              font-size: 0.2rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              bottom: 0;
            }
          }
          .img3 {
            width: 3.87rem;
            height: 2.89rem;
            position: relative;
            margin-bottom: 0.1rem;
            background: url("../../assets/images/72.png") no-repeat center;
            background-size: 100% 100%;
            .text {
              width: 100%;
              height: 0.52rem;
              background: rgba(0, 0, 0, 0.2);
              font-size: 0.2rem;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #ffffff;
              display: flex;
              justify-content: center;
              align-items: center;
              position: absolute;
              bottom: 0;
            }
          }
          .shijian {
            font-size: 0.18rem;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #000000;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .syxs:nth-child(1) {
          margin-left: 0;
        }
        .syxs:nth-child(3) {
          margin-right: 0;
        }
      }
    }
  }
  .rarterboxbox {
    width: 100%;
    background: #fbfbfb;
    padding-bottom: 1.5rem;
    .rarterbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 0.73rem;

      .btbox {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        .bttext1 {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.35rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #313131;
        }
        .bttext2 {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.16rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
        }
      }
      .hezidebox {
        display: flex;
        .shangpinsbox {
          .shangpins {
            width: 4rem;
            height: 1.6rem;
            border-bottom: 1px solid #e1e0e0;
            padding-right: 0.57rem;
            padding-bottom: 0.15rem;
            padding-top: 0.15rem;
            padding-left: 0.5rem;
            .img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .shangpins:nth-child(1) {
            margin-left: 0rem;
          }
          .shangpins:nth-child(3) {
            margin-right: 0rem;
            border-bottom: none;
          }
        }

        .shugang {
          width: 0.01rem;
          height: 4.8rem;
          background: #e1e0e0;
        }
      }
    }
    .lbttbox {
      width: 12rem;
      margin: 0 auto;
      .hezidebox {
        display: flex;
        .shangpinsbox {
          .shangpins {
            width: 4rem;
            height: 1.6rem;
            border-bottom: 1px solid #e1e0e0;
            padding-right: 0.57rem;
            padding-bottom: 0.15rem;
            padding-top: 0.15rem;
            padding-left: 0.5rem;
            .img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .shangpins:nth-child(1) {
            margin-left: 0rem;
          }
          .shangpins:nth-child(3) {
            margin-right: 0rem;
            border-bottom: none;
          }
        }

        .shugang {
          width: 0.01rem;
          height: 4.8rem;
          background: #e1e0e0;
        }
      }
    }
  }
  .tijiaoboxbox {
    width: 100%;
    background: url("../../assets/images/jiao.png") no-repeat center;
    background-size: 100% 100%;
    .tijiaobox {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 0.5rem;
      .biaoti {
        font-size: 0.42rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding-top: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.9rem;
      }
      .biaogebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        flex-wrap: wrap;
        .biaoge {
          width: 2.76rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.1rem;
          margin-left: 0.11rem;
          margin-right: 0.11rem;
          margin-bottom: 0.2rem;
          .index {
            width: 100%;
            height: 100%;
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            border: none;
          }
        }
      }
      .tijiaobtn {
        width: 1.62rem;
        height: 0.5rem;
        border: 0.02rem solid #ffffff;
        border-radius: 0.1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
@media (max-width: 750px) {
  // .home{display: none!important;}
  .tijiaobox {
    width: 600px !important;
  }
  .my-swipe {
    width: 600px !important;
  }
  .lbBoxtext {
    width: 600px !important;
  }
  .lqd {
    width: 600px !important;
  }
  .boxbox {
    width: 600px !important;
  }
  .rarterbox {
    width: 600px !important;
  }
  .sxybox {
    width: 600px !important;
  }
  .gg2xuanxBox {
    width: 600px !important;
  }
  .nr {
    width: 600px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/index.vue